import { Injectable } from '@angular/core';
import { delay, Observable, of, throwError } from 'rxjs';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';
export type TyreStatus = 'Good' | 'Fair' | 'Poor';

export interface Tyre {
  serialNo: string;
  brand: string;
  model: string;
  mfgDate: string;
  kmsRun: number;
  lastRepair: string;
  status: TyreStatus;
}
export interface TyreApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}
@Injectable({
  providedIn: 'root'
})
export class ordersService {
    private readonly DUMMY_TYRES: Tyre[] = [
    { serialNo: 'SN-2312',     brand: 'Apollo',     model: 'EnduRace',       mfgDate: '12/2023', kmsRun: 1222,  lastRepair: '04/2024', status: 'Good' },
    { serialNo: 'SN-12321312', brand: 'CEAT',       model: 'Winrage',        mfgDate: '12/2023', kmsRun: 1221,  lastRepair: '04/2024', status: 'Good' },
    { serialNo: 'SN-2321312',  brand: 'Apollo',     model: 'EnduTranz',      mfgDate: '12/2023', kmsRun: 2311,  lastRepair: '04/2024', status: 'Fair' },
    { serialNo: 'SN-12312312', brand: 'CEAT',       model: 'Miles XL',       mfgDate: '12/2023', kmsRun: 2341,  lastRepair: '04/2024', status: 'Fair' },
    { serialNo: 'SN-3312001',  brand: 'MRF',        model: 'ZLX',            mfgDate: '03/2023', kmsRun: 4512,  lastRepair: '01/2024', status: 'Poor' },
    { serialNo: 'SN-4421123',  brand: 'Apollo',     model: 'EnduRace HD',    mfgDate: '06/2023', kmsRun: 3210,  lastRepair: '02/2024', status: 'Good' },
    { serialNo: 'SN-5533889',  brand: 'CEAT',       model: 'Aashirvad',      mfgDate: '09/2023', kmsRun: 890,   lastRepair: '03/2024', status: 'Good' },
    { serialNo: 'SN-6622774',  brand: 'JK Tyre',   model: 'Jumbo King',     mfgDate: '11/2022', kmsRun: 8721,  lastRepair: '11/2023', status: 'Poor' },
    { serialNo: 'SN-7741002',  brand: 'MRF',        model: 'Steel Muscle',   mfgDate: '01/2024', kmsRun: 310,   lastRepair: '04/2024', status: 'Good' },
    { serialNo: 'SN-8855112',  brand: 'Bridgestone',model: 'R249',           mfgDate: '08/2023', kmsRun: 5102,  lastRepair: '12/2023', status: 'Fair' },
    { serialNo: 'SN-9963001',  brand: 'Apollo',     model: 'EnduPro',        mfgDate: '05/2023', kmsRun: 6340,  lastRepair: '10/2023', status: 'Fair' },
    { serialNo: 'SN-1012345',  brand: 'CEAT',       model: 'CrossDrive',     mfgDate: '07/2022', kmsRun: 12450, lastRepair: '08/2023', status: 'Poor' },
  ];


  constructor(private api : ApiService) { }

  getOrders(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}fms-service/job/getJobs?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
} 
  getDraftJobs(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}fms-service/job/getDraftJobs?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
} 

addOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'fms-service/job/addOrUpdate')
  return this.api.post(url,formData);
}
draftAddOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'fms-service/job/draftAddOrUpdate')
  return this.api.post(url,formData);
}
bulkAddOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ems-service/budget/bulkAddOrUpdate')
  return this.api.post(url,formData);
}
getRoleMappingList(){
  const url = `${environment.New_BASE_DOMAIN}auth-service/role/getRoleMappingList`;
  return this.api.get(url);
} 

getBudgetTransactions(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ems-service/budget/getBudgetTransactions?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=updatedAt&direction=DESC`;
  return this.api.post(url,formData);
}
getLineItemTransactions(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}fms-service/job/getLineItemTransactions?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=updatedAt&direction=ASC`;
  return this.api.post(url,formData);
}

updateLineItems(payload:any){
  const url = (environment.New_BASE_DOMAIN + 'fms-service/job/addOrUpdate')
  return this.api.post(url,payload);
}
getAssociateList(payload:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}fms-service/user/getUsers?pageNumber=${pageNumber}&pageSize=${pageSize}&direction=ASC`;
  return this.api.post(url,payload);
}


getLocations(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}fms-service/location/getLocations?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
getVehicleType(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}fms-service/vehicle/getVehicleType?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
} 
getMaterialType(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}fms-service/vehicle/getMaterialType?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
} 
getRoutes(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}fms-service/route/getRoutes?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
getAccounts(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}account-service/account/getAccountInfo?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
  }


  getTruckInfo(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}fms-service/truck/getTruckInfo?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
  } 

  
  getTruckBuild(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}fms-service/truck/getTruckBuild?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
  } 
   getTruckBuildById(id:any){
    const url = `${environment.New_BASE_DOMAIN}fms-service/truck/getTruckBuildById?truckBuildId=${id}`;
    return this.api.post(url,id);
  } 

  
   getBuild(data:any){
    const url = `${environment.New_BASE_DOMAIN}fms-service/truck/build`;
    return this.api.post(url,data);
  } 
    
   getTruckTransactions(data:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}fms-service/truck/getTruckTransactions?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,data);
  } 

  dashboardLedger(){
    const url = `${environment.New_BASE_DOMAIN}fms-service/truck/dashboardLedger
    `;
    // ?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}
    return this.api.get(url);
  } 


  

  parseCustomDate(dateString: string): Date | null {
  if (!dateString) return null;

  const parts = dateString.split(' ');
  const datePart = parts[0];      // 18-09-2025
  const timePart = parts[1];      // 15:53:15

  const [day, month, year] = datePart.split('-').map(Number);
  const [hour, minute, second] = timePart.split(':').map(Number);

  return new Date(year, month - 1, day, hour, minute, second);
}
}
